import { render } from "./ModalBloquear.vue?vue&type=template&id=4c21a1e2&scoped=true"
import script from "./ModalBloquear.vue?vue&type=script&lang=js"
export * from "./ModalBloquear.vue?vue&type=script&lang=js"

import "./ModalBloquear.vue?vue&type=style&index=0&id=4c21a1e2&scoped=true&lang=css"

import exportComponent from "/home/mauro/proyectos/vue-genesis-observability/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c21a1e2"]])

export default __exports__